import * as React from 'react';
import { EngineeringReviewList } from '../../../../modules/ordering/models/engineering-review-list';
import { toSlashedShortDate } from '../../../../utils/date-utils';

interface IProps {
    onOrderClick: any;
    order: EngineeringReviewList;
}

export const WindloadOrderRow = (props: IProps) => {

    return (
        <tr onClick={() => props.onOrderClick(props.order.orderId)}>
            <td><a>{props.order.orderId}</a></td>
            <td>{props.order.description}</td>
            <td>{props.order.cutoffDate ? toSlashedShortDate(props.order.cutoffDate) : ''}</td>
        </tr>
    );
};
